<template>
  <div id="arcgis-map-container" class="device-map">
    <el-autocomplete
      v-model="filterText"
      :fetch-suggestions="querySearch"
      placeholder="请输入内容"
      @select="handleSelect"
    >
      <img slot="prefix" src="@/assets/img/icon_search.png">
    </el-autocomplete>
    <arcgis-map
      :url="mapUrl"
      :zoom.sync="mapZoom"
      :center.sync="mapCenter"
      :mapLoad="handleMapLoad"
      :extentChange="handleExtentChange"
      :boxSelectStart="handleBoxSelectStart"
      :boxSelectComplete="handleBoxSelectComplete"
      :mapUnload="handleMapUnload"
      ref="arcgisMap"
    ></arcgis-map>

    <!--显示视频节点信息弹窗-->
    <show-stream-node-modal v-if="streamNodeModalOpen" :modalOpen="streamNodeModalOpen" :gisMarker="currentGismarker" @cancel="handleStreamNodeModalCancel"></show-stream-node-modal>

    <!--视频播放器窗口-->
    <video-player-modal v-if="videoPlayerModalOpen" :modalOpen="videoPlayerModalOpen" :streamNodes="selectedGismarkers" :videoOpen="videoPlayerModalVideoOpen" @cancel="handleVideoPlayerModalCancel"></video-player-modal>
  </div>
</template>
<script type="text/ecmascript-6">
import DeviceMap from './DeviceMap.js'
export default DeviceMap
</script>
<style lang="scss">
@import "DeviceMap";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/deviceMap/DeviceMap.vue